import { render, staticRenderFns } from "./ManageNotificationTemplates.vue?vue&type=template&id=49d80d66&scoped=true"
import script from "./ManageNotificationTemplates.vue?vue&type=script&lang=js"
export * from "./ManageNotificationTemplates.vue?vue&type=script&lang=js"
import style0 from "./ManageNotificationTemplates.vue?vue&type=style&index=0&id=49d80d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d80d66",
  null
  
)

export default component.exports